interface MediaItem {
  id: string;
  media_url?: string;
  caption?: string;
}

interface MediaGridProps {
  items?: MediaItem[];
}

export default function MediaGrid({ items = [] }: MediaGridProps) {
  if (!items.length) {
    return <div className="rounded-xl border border-dashed border-sand/70 p-6 text-center text-sm text-cocoa/60">No media yet.</div>;
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
      {items.map((item) => (
        <article key={item.id} className="overflow-hidden rounded-xl bg-white/80 shadow-soft">
          <div className="aspect-video overflow-hidden bg-sand/40">
            {item.media_url?.match(/\.mp4|\.mov|\.webm/i) ? (
              <video src={item.media_url} controls className="h-full w-full object-cover" />
            ) : (
              <img src={item.media_url} alt={item.caption || 'Prospect update'} className="h-full w-full object-cover" />
            )}
          </div>
          {item.caption ? <p className="p-3 text-sm text-cocoa/80">{item.caption}</p> : null}
        </article>
      ))}
    </div>
  );
}
